module.exports = __webpack_public_path__ + "img/ahmed.54f72b69.jpg";